import * as React from 'react';

const classNames = require('classnames');
const styles = require('./OptionDescription.scss');

export interface OptionDescriptionProps extends React.HTMLAttributes<HTMLParagraphElement> {
    children?: React.ReactNode;
}

export default function OptionDescription(props: OptionDescriptionProps) {
    return (
        <p {...props} className={classNames(props.className, styles.description)}>
            {props.children}
        </p>
    );
}
